import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { FertilizerProductId } from 'services/fertilizerProducts/types';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductNPK } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
}

type Props = OwnProps;

export default function ProductNPKTableCell(props: Props): React.ReactElement {
    const npk = useSelector((state: AppState) =>
        makeSelectProductNPK()(state, props)
    );

    return <TableCell>{npk}</TableCell>;
}
